<template>
  <div>
    <div class="d-flex">
      <!-- <fixed-label-filter label="活跃频率">
        <a-select v-model="selectedDay" style="width:120px" @change="changeDayType">
          <a-select-option value="3">3天内</a-select-option>
          <a-select-option value="30">30天内</a-select-option>
        </a-select>
      </fixed-label-filter> -->
      <fixed-label-filter label="数据类型">
        <a-select v-model="dataType" style="width:120px">
          <a-select-option v-for="(item) in opts" :key="item.key" :value="item.key">{{item.label}}</a-select-option>
        </a-select>
      </fixed-label-filter>
    </div>
    <a-row :gutter="8" class="mt-2">
      <a-col>
        <user-chart :data="data" :opt="currentOpt" />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import UserChart from './charts/user'

export default {
  name: 'ChartList',
  components: {
    UserChart,
  },
  props: {
    dayType: [String, Number],
    changeDayType: Function,
  },
  data () {
    return {
      data: [],
      dataType: 'active_user',
      opts: [
        {
          key: 'active_user',
          label: '活跃用户',
          lines: [{ key: 'active_user3_days', label: '3天内' }, { key: 'active_user30_days', label: '30天内' }],
        },
        {
          key: 'user',
          label: '用户',
          lines: [{ key: 'user3_days', label: '3天内' }, { key: 'user30_days', label: '30天内' }],
        },
        {
          key: 'kvm',
          label: 'KVM主机',
          lines: [{ key: 'kvm3_days', label: '3天内' }, { key: 'kvm30_days', label: '30天内' }],
        },
        {
          key: 'vm',
          label: '虚机',
          lines: [{ key: 'vm3_days', label: '3天内' }, { key: 'vm30_days', label: '30天内' }],
        },
        {
          key: 'baremetal',
          label: '裸金属',
          lines: [{ key: 'baremetal3_days', label: '3天内' }, { key: 'baremetal30_days', label: '30天内' }],
        },
        {
          key: 'github_stars',
          label: 'GITHUB',
          lines: [{ key: 'github_stars', label: 'Stars' }],
        },
        {
          key: 'portal_users',
          label: '注册用户',
          lines: [{ key: 'github_stars', label: 'Stars' }],
        },
        {
          key: 'license_count',
          label: '授权数',
          lines: [{ key: 'license_count', label: '有效' }, { key: 'valid_license_count', label: '累计' }],
        },
        {
          key: 'saas',
          label: 'SaaS',
          lines: [{ key: 'saas_accounts', label: '云账号' }, { key: 'saas_servers', label: '主机' }],
        },
        {
          key: 'wechat_followers',
          label: '公众号',
          lines: [{ key: 'wechat_followers', label: '用户数' }],
        },
        {
          key: 'group_users',
          label: '微信用户',
          lines: [{ key: 'group_users', label: '用户数' }],
        },
      ],
    }
  },
  computed: {
    currentOpt () {
      return (this.opts.filter(item => item.key === this.dataType))[0]
    },
  },
  created () {
    this.$rM = new this.$Manager('operation_records', 'v2')
    this.fetchAnalysis()
  },
  methods: {
    fetchAnalysis () {
      const params = { force_no_paging: true }
      this.$rM.list({
        params,
      }).then(res => {
        this.data = res.data.data
      })
    },
  },
}
</script>
